import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, catchError, map } from "rxjs";
import { IKtoDetails, ITokenDetails } from "../shared/models";
import { apiUrlConstant } from "../utils/constant/apiUrl.constant";
import { KTO_SYMBOL } from "../utils/constant/common.constant";
import { LOCAL_STORAGE_KEYS } from "../utils/enum";
import { ApiService } from "./api.service";
import { LocalStorageProvider } from "./localStorage";
import { PopupService } from "./popup.service";

@Injectable()
export class SharedDataService {
  public walletBalace: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public totalBalace: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    private localStorageService: LocalStorageProvider,
    private apiService: ApiService,
    public toastService: PopupService,
  ) { }

  setWalletBalance(newData: any) {
    this.walletBalace.next(newData);
  }

  getWalletBalance() {
    return this.walletBalace;
  }

  setTotalBal(bal: any) {
    // Crypto + FIAT
    this.totalBalace.next(bal);
  }

  getTotalBal() {
    return this.totalBalace;
  }

  /**
   * Gets Wallet details according to the currencySymbol of the wallet required
   * @param currencySymbol - Currency symbol of wallet to be fetched i.e. "KTO" or "USD"
   * @returns Specific Object of wallet matching the currency
   */
  getWalletDetails(currencySymbol: string) {
    const combinedWallets = this.localStorageService.getItem(
      LOCAL_STORAGE_KEYS.WALLET_DETAILS,
    ) as any[];
    if (!combinedWallets?.length) {
      return {};
    }

    // Gets the wallet details for specific wallet according to currency symbol
    return combinedWallets.filter(
      (wallet) => wallet.currency.symbol === currencySymbol,
    )[0];
  }

  getKTOPrice(): Observable<IKtoDetails> {
    const tokenDetail: IKtoDetails = {
      symbol: "kto",
      current_price: 0,
      image: "",
    };

    return this.apiService
      .getData(`${apiUrlConstant.getTokenPrice}?symbol=${KTO_SYMBOL}`)
      .pipe(
        map((res) => {
          if (res?.success) {
            const { current_price, image } = res.result;
            tokenDetail.current_price = current_price;
            tokenDetail.image = image;
          }
          return tokenDetail;
        }),
      );
  }

  getTokenDetails(
    tokenId?: number,
    tokenSymbol?: string,
  ): Observable<ITokenDetails | any> {
    let url = `symbol=${tokenSymbol ?? "kto"}`;
    if (tokenId !== undefined && tokenId > -1) {
      url = `id=${tokenId}`;
    }
    return this.apiService
      .getData(`${apiUrlConstant.getTokenData}?${url}`)
      .pipe(
        map((response) => {
          if (response.success) {
            return response.result;
          }
        }),
        catchError((err) => {
          return err?.error?.message ?? err.message;
        }),
      );
  }

  getTokenPrice(tokenId?: number, tokenSymbol?: string) {
    let url = `symbol=${tokenSymbol ?? KTO_SYMBOL}`;
    if (tokenId) {
      url = `id=${tokenId}`;
    }
    return this.apiService
      .getData(`${apiUrlConstant.getTokenPrice}?${url}`)
      .pipe(
        map((response) => {
          if (response.success) {
            return response.result;
          }
        }),
        catchError((err) => {
          return err?.error?.message ?? err.message;
        }),
      );
  }
}
